// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@vanmeter/Overrides/Components/ProductCarouselProduct";
import { CarouselCardType } from "@vanmeter/XDL/types";
import { sharedOverlayBadgeStyles, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductStyles.productAddToListLinkStyles = {};

productCarouselProductStyles.productDescriptionStyles = {
    descriptionWrapper: {
        css: css`
            margin-bottom: 0;
        `,
    },
};

productCarouselProductStyles.qtyNumbersStyles = {
    container: {
        css: css`
            flex-direction: row;
            justify-content: space-between;
            margin-top: 4px;
        `,
    },
};

productCarouselProductStyles.badgeAreaWrapper = {
    ...sharedOverlayBadgeStyles.badgeAreaWrapper,
};

productCarouselProductStyles.badgeImageWrapper = {
    ...sharedOverlayBadgeStyles.badgeImageWrapper,
};

productCarouselProductStyles.badgeTextWrapper = {
    ...sharedOverlayBadgeStyles.badgeTextWrapper,
};

productCarouselProductStyles.badgeText = {
    ...sharedOverlayBadgeStyles.badgeText,
};

productCarouselProductStyles.badgeImageProps = {
    ...sharedOverlayBadgeStyles.badgeImageProps,
};

productCarouselProductStyles.availabilityStyles = {
    container: {
        css: css`
            ${({ view }: any) =>
                view === CarouselCardType.Condensed &&
                css`
                    flex-direction: column;
                    align-items: flex-start;
                `}
        `,
    },
};

productCarouselProductStyles.prevPurchasedTag = {
    textBadgeWrapperCss: {
        css: css`
            position: absolute;
            top: 0;
            left: 0;

            ${({ view }: any) => {
                if (view === CarouselCardType.Grid) {
                    return css`
                        ${xScreen("lte", "md")} {
                            top: 96px;
                        }
                    `;
                }

                if (view === CarouselCardType.MiniCard) {
                    return css`
                        top: 96px;
                    `;
                }

                return "";
            }}
        `,
    },
};

productCarouselProductStyles.customBadgeWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

productCarouselProductStyles.productGridContainerStyles = {
    container: {
        css: css`
            width: auto;
        `,
    },
};
